export const FETCH_ADD_HOURS = 'FETCH_ADD_HOURS';
export const FETCH_GET_HOURS = 'FETCH_GET_HOURS';
export const FETCH_DELETE_HOUR = 'FETCH_DELETE_HOUR';
